/**
 * Created by ivo on 06.05.14.
 */

define([
    'common',
    'jQuery',
    './widgetFactory',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-state/Scope',
    'library/fcse-state/urlHandling',
    'clientComponents/countbutton/countButtonExtended',
    'library/fcse-visibilitycontrol/visibilityControl',
    'clientComponents/teaserslider/teaserSlider',
    'clientComponents/searchmaskloader/searchmaskloader',
    'clientComponents/bottombar/bottomBar',
    'clientComponents/usersearchprefill/userSearchPrefillTracker',
    'clientComponents/googletagmanager/GtmManager',
    './cmsAdapter'
], function (
    common,
    $,
    WidgetFactory,
    MultiRequestHandler,
    Scope,
    UrlHandling,
    CountButton,
    VisibilityControl,
    TeaserSlider,
    SearchmaskLoader,
    BottomBar,
    UserSearchPrefillTracker,
    GtmManager
) {

    var params = {};
    if (typeof window.productSearchParams !== 'undefined') {
        params = window.productSearchParams;
    }
    // Create scopes
    var rootScope = new Scope(null, null, null, params);
    var localScope = new Scope(rootScope);
    localScope.setParam('bookingType', 'package');

    // Create widget factory
    var widgetFactory = new WidgetFactory({rootScope: rootScope, localScope: localScope});

    // Initialize Multirequest-Handler
    var requestHandler = new MultiRequestHandler();

    // Initialize Button
    var countButton = new CountButton(requestHandler, rootScope, '[data-fcse-role="countbutton"]', {
        updateRoute: 'allt_frontend.package.update_count'
    });

    new VisibilityControl('[data-searchmask-toggle]', {
        'targetSelectorAttribute': 'data-searchmask-toggle',
        'elementTargetIsVisibleClass': 'is-active',
        'targetIsVisibleClass': 'is-toggled',
        'targetIsHiddenClass': 'is-not-active'
    });

    // Teaser Slider
    var teaserSlider = new TeaserSlider('[data-fcse-role=teaser-slider]');

    // Add VisibilityControl
    var visibilityControl = new VisibilityControl('[data-fcse-role="visibility-control"]', {
        'targetIsVisibleClass': 'is-active',
        'targetIsHiddenClass': 'is-collapsed'
    });
    var searchmaskLoader = new SearchmaskLoader($('[data-fcse-role="searchmask-container"]'));

    var bottomBar = new BottomBar($('[data-fcse-role="bottom-bar"]'));

    var searchPrefill = new UserSearchPrefillTracker();
    searchPrefill.registerScope(rootScope);

    // Enable URL History
    if (typeof history.pushState != 'undefined') {
        UrlHandling.enableBrowserHistory(rootScope);
    }

    try{
        GtmManager
            .setOptions({scope: rootScope, stateHandler: requestHandler})
            .initPageTracker('commonPage', {
                country: $('[data-page-locale]').first().data('page-locale'),
                pageType: 'other'
            });
    } catch (e) {
        console.log(e);
    }
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/pmpage/index.js